import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CargadorPcPage } from '@pages';
import { DesafioPersonalProvider } from '@providers/desafio-personal/desafio-personal';

@IonicPage()
@Component({
  selector: 'page-info-bots',
  templateUrl: 'info-bots.html',
})
export class InfoBotsPage {

  pager: boolean;
  jugador: any;
  equipo: any;
  bot: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private desafioPersonalProvider: DesafioPersonalProvider,
  ) {
    this.pager = true;
    
    this.jugador = this.navParams.get('jugador');
    this.equipo = this.navParams.get('equipo');
    this.bot = this.navParams.get('bot');
  }

  ionViewDidLoad() {
  }

  close() {
    this.desafioPersonalProvider.ocultaModalBots();

    this.navCtrl.setRoot(CargadorPcPage, {
      jugador: this.jugador,
      equipo: this.equipo,
      bot: this.bot
    });
  }

  isEnd(event) {
    this.pager = !event.isEnd();
  }

}



// WEBPACK FOOTER //
// ./src/pages/info-bots/info-bots.ts